import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';

class Icon extends Component {
    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _onClick(evt) {
        const {
            onClick
        } = this.props;

        if (onClick) {
            onClick(evt);
        }
    }

    render() {
        const {
            className,
            name
        } = this.props;
        const classes = classNames(
            'Icon',
            `icon-${name}`,
            className
        );

        return <i className={classes} onClick={this._onClick} />;
    }
}

Icon.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

Icon.defaultProps = {
    className: ''
};

export default Icon;



// WEBPACK FOOTER //
// ./frontend/src/js/components/icon/Icon.jsx